export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const RESET_STATE = "resetModuleState";

export const FETCH_END = "setEmployees";
export const FETCH_START = "setLoading";
export const UPDATE_EMPLOYEE_IN_LIST = "updateEmployeeInList";
export const SET_EMPLOYEE = "setEmployee";

export const SET_DEPENDENT = "setDependent";

export const SET_UNIT = "setUnit";

export const SET_INSURANCE = "setInsurance";

export const SET_MANIFEST = "setManifest";
